export const nav = 1;
export const BASE = "parts-orders";

export const getStates = (menu, other) => {
  const base = menu ? `${menu}.${BASE}` : BASE;
  return {
    // ["new-parts-order"]: {
    //   menu,
    //   nav,
    //   icon: "barcode",
    //   url: "/new-parts-order",
    //   title: "New Parts Order",
    //   params: {}
    // },
    [base]: {
      nav,
      menu, // <ui-view/>
      breadcrumbs: false,
      pageHeader: false,
      icon: "usd",
      title: "Parts Orders",
      url: "/" + BASE, // + "?uploaded&mode",
      params: {},
      rerouteTo: `${base}.list`,
      resolve: {
        retailerId: ($window, $stateParams) => $stateParams.retailerId
      },
      templateProvider: $stateParams => `<parts-order-container />`,
      ...other
    },
    [`${base}.list`]: {
      menu: base,
      nav: false,
      breadcrumbs: false,
      pageHeader: false,
      icon: "usd",
      title: "List",
      resolve: {},
      templateProvider: $stateParams => `<parts-order-list  />`
    },
    [`${base}.detail`]: {
      menu: base,
      nav: false,
      url: "/{orderId:[^/]+}",
      title: "Detail",
      breadcrumbs: false,
      pageHeader: false,
      params: {},
      resolve: {
        orderId: ($window, $stateParams) => $stateParams.orderId
      },
      templateProvider: $stateParams => `<parts-order-details order-id=${$stateParams.orderId} />`
    }
  };
};

export default getStates();
